(function(){ /* cwv-lcp-fix-20260811 */

  function init(){
    document.body.classList.add('watl-active');
    var buybox=document.querySelector('[data-watl-buybox]');
    var bar=document.querySelector('[data-wped-sticky-atc]');
    if(buybox && bar && 'IntersectionObserver' in window){
      new IntersectionObserver(function(e){
        if(e[0].isIntersecting){ bar.setAttribute('hidden',''); }
        else { bar.removeAttribute('hidden'); }
      },{threshold:0}).observe(buybox);
    }

    var mainImg=document.querySelector('[data-watl-main-img]');
    var thumbs=[].slice.call(document.querySelectorAll('[data-watl-thumb]'));

    function fileKey(url){
      if(!url) return '';
      var n=String(url).split('?')[0];
      var parts=n.split('/');
      return (parts[parts.length-1]||'').toLowerCase();
    }

    function withWidth(url, w){
      if(!url) return url;
      var base=String(url).split('?')[0];
      var q=String(url).indexOf('?')>=0 ? String(url).slice(String(url).indexOf('?')+1) : '';
      var parts=q ? q.split('&').filter(function(p){ return p && p.indexOf('width=')!==0; }) : [];
      parts.push('width='+w);
      return base+'?'+parts.join('&');
    }
    function applyMainSrc(src){
      if(!mainImg || !src) return;
      if(src.indexOf('//')===0) src='https:'+src;
      mainImg.src=withWidth(src, 960);
      mainImg.setAttribute('srcset', [480,720,960,1200].map(function(w){ return withWidth(src,w)+' '+w+'w'; }).join(', '));
      mainImg.setAttribute('sizes', '(max-width: 749px) 100vw, min(58vw, 840px)');
    }
    function setMainImage(src, opts){
      opts=opts||{};
      if(!mainImg || !src) return;
      applyMainSrc(src);

      var key=fileKey(src);
      var matched=false;
      thumbs.forEach(function(thumb){
        var full=thumb.getAttribute('data-full')||'';
        var img=thumb.querySelector('img');
        var thumbSrc=(img && img.getAttribute('src'))||'';
        var active=key && (fileKey(full)===key || fileKey(thumbSrc)===key);
        thumb.classList.toggle('is-active', !!active);
        if(active) matched=true;
      });
      if(!matched && opts.clearThumbActive){
        thumbs.forEach(function(thumb){ thumb.classList.remove('is-active'); });
      }
    }

    thumbs.forEach(function(btn){
      btn.addEventListener('click',function(){
        thumbs.forEach(function(x){x.classList.remove('is-active')});
        btn.classList.add('is-active');
        var src=btn.getAttribute('data-full') || (btn.querySelector('img')||{}).src;
        if(mainImg && src){
          applyMainSrc(src);
        }
      });
    });

    // Fallback only if swatch has no media attrs (legacy).
    var exactVariantImages={
      Black:'https://cdn.shopify.com/s/files/1/0761/9657/7516/files/German16pcsknife6-lcp.jpg?v=1786444254',
      White:'https://cdn.shopify.com/s/files/1/0761/9657/7516/files/5_80531f85-d3e6-439e-9a5a-d2beb81a7aed.jpg?v=1784135789'
    };

    function applyVariantImage(btn){
      if(!btn || !mainImg) return;
      var mediaUrl=btn.getAttribute('data-media-url');
      var value=btn.getAttribute('data-display-value') || btn.getAttribute('data-value');
      var src=mediaUrl || (value && exactVariantImages[value]) || '';
      if(!src) return;
      if(src.indexOf('//')===0) src='https:'+src;
      setMainImage(src, { clearThumbActive: true });
    }

    document.querySelectorAll('.watl-buybox [data-wped-swatch]').forEach(function(btn){
      btn.addEventListener('click',function(){
        applyVariantImage(btn);
      });
    });

    // Keep gallery in sync when buy-bar updates selection.
    document.addEventListener('wped:variant-change', function(){
      var selected=document.querySelector('.watl-buybox [data-wped-swatch].is-selected');
      if(selected) applyVariantImage(selected);
    });

    function syncStickyMarketPrice(){
      var stickyPrice=document.querySelector('[data-wped-sticky-price]');
      var selected=document.querySelector('.watl-buybox [data-wped-swatch].is-selected');
      var heroPrice=document.querySelector('.watl-buybox [data-wped-price]');
      var formatted=selected && selected.getAttribute('data-price-formatted');
      if(!formatted && heroPrice) formatted=heroPrice.textContent.trim();
      if(stickyPrice && formatted) stickyPrice.textContent=formatted;
    }
    document.addEventListener('wped:price-updated',function(){setTimeout(syncStickyMarketPrice,0);});
    setTimeout(syncStickyMarketPrice,0);
    setTimeout(syncStickyMarketPrice,250);
    if('IntersectionObserver' in window){
      var ro=new IntersectionObserver(function(es){
        es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');ro.unobserve(en.target);}});
      },{threshold:0.16});
      document.querySelectorAll('.watl-reveal').forEach(function(el){ro.observe(el);});
    } else {
      document.querySelectorAll('.watl-reveal').forEach(function(el){el.classList.add('is-in');});
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
